import PageApp from 'pageApp';
import $ from 'jquery';
import Storage from '@component/common/src/util/ClientSideStorage';
import Cookie from '@component/common/src/util/Cookie';
import Util from '../util/Util';
import Constants from '../util/Constants';

export default class AddToListHandler {
  static bindAddToListListener($prosContainer) {
    if (Util.internationalOrRegistryMode()) { return; }

    const self = this;
    $prosContainer.on('click', '.altContainer', (e) => {
      e.stopPropagation();
      e.preventDefault();
      // Add to list
      const $el = $(e.currentTarget);
      const productId = $el.closest('.productThumbnail').attr('id');
      if ($el.hasClass('icon-gen-heart-gr-large')) {
        self.addToList(productId, $el);
      } else {
        self.removeFromList(productId, $el);
      }
    });
  }
  static addToList(productId, $el) {
    const self = this;
    const userId = Cookie.get('macys_online_uid');
    const url = '/xapi/wishlist/v1/favorites';
    const reqData = {
      CustomerList: {
        list: [{
          items: [{
            qtyRequested: 1,
            product: {
              id: `${productId}`,
            },
          }],
        }],
      },
    };
    if (userId) {
      reqData.CustomerList.user = {
        id: userId,
      };
    }
    $.ajax({
      type: 'POST',
      url,
      data: JSON.stringify(reqData),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done((data, status, jqXHR) => {
        self.addToListSuccessHandler(data, jqXHR, $el, productId);
      })
      .fail((jqXHR) => {
        self.addToListErrorHandler(jqXHR, $el);
      });
  }
  static removeFromList(productId, $el) {
    const self = this;
    const listGuid = Storage.getSession('listGuid') || '';
    const url = `/xapi/wishlist/v1/favorites/${listGuid}?productId=${productId}`;
    $.ajax({
      type: 'DELETE',
      url,
      contentType: 'application/json',
      dataType: 'json',

    })
      .done((data, status, jqXHR) => {
        self.removeFromListSuccessHandler(data, jqXHR, $el, productId);
      })
      .fail((jqXHR) => {
        self.removeFromListErrorHandler(jqXHR, $el, productId);
      });
  }
  static addToListSuccessHandler(dataObj, jqXHR, $el, productId) {
    const self = this;
    const timeoutWindow = 2592000000;
    const listItems = Storage.getSession('listItems');
    if (dataObj.errors) {
      self.addToListErrorHandler(jqXHR, $el);
    } else {
      if (dataObj.CustomerList && dataObj.CustomerList.list && dataObj.CustomerList.list.length > 0 && dataObj.CustomerList.list[0].listGuid) {
        Storage.setSession('listGuid', dataObj.CustomerList.list[0].listGuid);
        if (listItems) {
          if (listItems.indexOf(productId) === -1) {
            Storage.setSession('listItems', `${listItems},${productId}`);
          }
        } else {
          Storage.setSession('listItems', `${productId}`);
        }
      }
      if (dataObj.CustomerList && dataObj.CustomerList.user) {
        if (dataObj.CustomerList.user.guid && !Cookie.get('macys_online_guid')) {
          Cookie.set('macys_online_guid', dataObj.CustomerList.user.guid, undefined, {
            expires: new Date(new Date().getTime() + timeoutWindow),
          });
        }
        if (dataObj.CustomerList.user.id && !Cookie.get('macys_online_uid')) {
          Cookie.set('macys_online_uid', dataObj.CustomerList.user.id, undefined, {
            expires: new Date(new Date().getTime() + timeoutWindow),
          });
        }
      }
      $el.removeClass('icon-gen-heart-gr-large').addClass('icon-gen-heart-red-large').attr('title', 'Remove From Default List');
      self.showATLMsg(Constants.HEARTING_MSGS.ADDED_TO_LIST, $el);
      PageApp.channel.trigger('pros-factory:addedToList:item', productId);
      // fire tealium adobe tags
      $el.closest('.pros-factory-carousel').trigger('component::addToList::toggle', { eventName: 'wishlist add', productId, eventType: 'favourite add' });
    }
  }
  static removeFromListSuccessHandler(data, jqXHR, $el, productId) {
    const self = this;
    const listItems = Storage.getSession('listItems');
    if (data && data.errors) {
      self.removeFromListErrorHandler(jqXHR, $el);
    } else {
      $el.removeClass('icon-gen-heart-red-large').addClass('icon-gen-heart-gr-large').attr('title', 'Add To Default List');
      if (listItems) {
        const listArray = listItems.split(',');
        const index = listArray.indexOf(productId);
        if (index >= 0) {
          listArray.splice(index, 1);
        }
        Storage.setSession('listItems', `${listArray.join(',')}`);
      }
      self.showATLMsg(Constants.HEARTING_MSGS.REMOVED_FROM_LIST, $el);
      PageApp.channel.trigger('pros-factory:removedFromList:item', productId);
      // fire tealium adobe tags
      $el.closest('.pros-factory-carousel').trigger('component::addToList::toggle', { eventName: 'wishlist remove', productId });
    }
  }
  static addToListErrorHandler(jqXHR, $el) {
    const self = this;
    self.showATLMsg(Constants.HEARTING_MSGS.UNABLE_TO_ADD, $el);
  }
  static removeFromListErrorHandler(jqXHR, $el, productId) {
    const self = this;
    if (jqXHR.statusText === 'OK') {
      self.removeFromListSuccessHandler({}, jqXHR, $el, productId);
    } else {
      self.showATLMsg(Constants.HEARTING_MSGS.UNABLE_TO_REMOVE, $el);
    }
  }
  static showATLMsg(message, $el) {
    const msgClass = 'confirmMsg';
    $el.closest('.productThumbnail').find('.altMessage').after(`<div class="${msgClass}">${message}</div>`);

    const msgElement = $el.closest('.productThumbnail').find(`.${msgClass}`);
    msgElement.delay(1000).fadeOut(1000, function () {
      $(this).remove();
    });
  }

  static canShowALTMsg(display) {
    return display === undefined || display === true;
  }
}
